var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBacktotop = function SvgBacktotop(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "current",
    viewBox: "0 0 55 54"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "current",
    d: "m27.5.707 19.199 19.199L27.5 53.004 8.301 19.906z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "current",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3,
    d: "M35.936 21.98 29.07 14.83a2.033 2.033 0 0 0-2.95 0l-6.866 7.151"
  })));
};
export default SvgBacktotop;